import { useLocation, useNavigate } from 'react-router-dom';
import { ListingTemplatesPage } from './ListingTemplatesPage';
import { MarketplaceReconciliationPage } from './MarketplaceReconciliationPage';
import { ReadyToListPage } from './ReadyToListPage';
import { EbayOperationsPage } from './EbayOperationsPage';
import { BuyerReturnsPage } from './BuyerReturnsPage';
import { useAuth } from '../auth/AuthContext';
import { hasAnyGroup } from '../auth/cognito';

type SalesSection = 'Reconciliation' | 'Templates' | 'Ready to List' | 'eBay' | 'Returns';

export function salesSectionFromPath(pathname: string): SalesSection {
  if (pathname.startsWith('/sales/returns')) return 'Returns';
  if (pathname.startsWith('/sales/reconciliation')) return 'Reconciliation';
  if (pathname.startsWith('/sales/templates')) return 'Templates';
  if (pathname.startsWith('/sales/ebay')) return 'eBay';
  if (pathname.startsWith('/sales/ready-to-list')) return 'Ready to List';
  return 'Ready to List';
}

export function MarketplacePage(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();
  const isAdmin = auth.claims !== null && hasAnyGroup(auth.claims, ['admin']);
  const section = salesSectionFromPath(location.pathname);

  return (
    <div className="tcvs-page">
      <header className="tcvs-page-header">
        <h1>Sales</h1>
        <p>Prepare listings and reconcile marketplace inventory.</p>
      </header>
      <nav className="tcvs-sales-tabs" aria-label="Sales sections">
        {(isAdmin
          ? (['Ready to List', 'eBay', 'Returns', 'Reconciliation', 'Templates'] as const)
          : (['Templates', 'Returns'] as const)
        ).map((item) => (
          <button
            key={item}
            type="button"
            onClick={() =>
              navigate(
                item === 'Returns'
                  ? '/sales/returns'
                  : item === 'Ready to List'
                    ? '/sales'
                    : item === 'eBay'
                      ? '/sales/ebay'
                      : item === 'Reconciliation'
                        ? '/sales/reconciliation'
                        : '/sales/templates',
              )
            }
            aria-pressed={item === section}
          >
            {item === 'Ready to List' ? 'Queue for release' : item}
          </button>
        ))}
      </nav>
      <div className="tcvs-storage-content">
        {section === 'Returns' ? <BuyerReturnsPage /> : null}
        {section === 'Reconciliation' ? <MarketplaceReconciliationPage /> : null}
        {section === 'Templates' ? <ListingTemplatesPage /> : null}
        {section === 'eBay' ? <EbayOperationsPage /> : null}
        {section === 'Ready to List' ? <ReadyToListPage /> : null}
      </div>
    </div>
  );
}
